import React, { Component } from 'react';
import {Trans} from "react-i18next";

export default class Support extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( <h1><Trans>Support</Trans></h1> );
    }
}
 
